import bannerImg from "./resource/banner.jpg"

function InnerHeader(){
    return(
        <div>
            <img src={bannerImg} style={{width:"100%",height:"300px", objectFit:"cover",objectPosition: "50% 60%", display:"block",  margin:"auto"}} />
        </div>
    )
}

export default InnerHeader;